import styled from 'styled-components';
import Icon from '../../assets/images/phone-icon.svg';

const PhoneIcon = styled.span`
    ${({ fill = '#FD7B7A' }) => `
        background-color: ${fill};
        mask-image: url("${Icon}");
        mask-position: center center;
        mask-repeat: no-repeat;
        mask-size: 100%;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        height: 28px;
        width: 28px;
    `}
}`;

export default PhoneIcon;
